//import React, { useState } from "react";
//import axios from "axios";

import React from "react";
import * as XLSX from "xlsx";
import SideBar from "../../Layout/Sidebar/SideBar";
import HeaderTop from "../../Layout/HeaderTop";
import { useRef, useState, useEffect, useContext } from "react";
//import AuthContext from '../context/AuthProvider';
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import axios from "../../api/axios";
import Swal from "sweetalert2";
import UnitMasterDDL from "../DropdownList/UnitMasterDDL";
import { DatePicker } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import { Layout, Space } from "antd";
import FooterBottom from "../../Layout/FooterBottom";
import SideMenu from "../../Layout/SideMenu";
import moment from "moment";
import dayjs from "dayjs";

const ImportApprovalAuthority = () => {
  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [EmployeeId, setEmployeeId] = useState("");
  const [EmployeeCardNo, setEmployeeCardNo] = useState("");
  const [EmployeeName, setEmployeeName] = useState("");
  const [ApproverId, setApproverId] = useState("");
  const [ApproverCardNo, setApproverCardNo] = useState("");
  const [ApproverName, setApproverName] = useState("");
  const [unitId, setUnitId] = useState(localStorage.getItem("unitId") || "");
  const [companyId, setCompanyId] = useState(localStorage.getItem("companyId") || "");

  const hideTd = true;

  const ImportApprovelAuthorityURL = "/ImportApprovelAuthority";
  const InsertApproverDetailsURL = "/InsertApproverDetails";

  const handleFileChange = (e) => {
    setCompanyId(localStorage.getItem("companyId"));
    setUnitId(localStorage.getItem("unitId"));
    setFile(e.target.files[0]);
  };
  

const handleImport = async () => {
    // setCompanyId(localStorage.getItem("companyId"));
    // setUnitId(localStorage.getItem("unitId"));
  if (!file) {
    setErrorMsg("Please upload an Excel file.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(ImportApprovelAuthorityURL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Response:", response.data); // Confirmed to be correct

    const formattedData = response.data
      .filter(
        (row) =>
          row.employeeId ||
          row.employeeName ||
          row.employeeCardNo ||
          row.approverId ||
          row.approverName ||
          row.approverCardNo
    
      )
      .map((row, index) => ({
        SerialNo: index + 1,
        EmployeeId: row.employeeId || "",
        EmployeeName: row.employeeName || "",
        EmployeeCardNo: row.employeeCardNo || "",
        ApproverId: row.approverId || "",
        ApproverName: row.approverName || "",
        ApproverCardNo: row.approverCardNo || "",
      }));

    setData(formattedData);
    setErrorMsg("");
    Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Approver datail inserted successfully",
              showConfirmButton: true,
              //timer: 1500,
            });
  } catch (error) {
    console.error("Import failed:", error);
    setErrorMsg("Failed to import data. Please try again.");
  }
};


  return (
    <div className="panel panel-default">
      <h2>Approval Authority</h2>
      <div className="panel-body">
        {errorMsg && (
          <div style={{ color: "red", marginBottom: "10px" }}>{errorMsg}</div>
        )}

        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-md-3 col-sm-12 col-xs-12">
            <input
              type="file"
              className="form-control"
              onChange={handleFileChange}
              accept=".xlsx,.xls"
            />
          </div>

          <div className="col-md-3 col-sm-12 col-xs-12">
            <button
              className="btn btn-sm theme-btn btn-success"
              onClick={handleImport}
            >
             Save Import Excel
            </button>
          </div>
        </div>
{/* <div className="table-responsive"> */}
        {/* <table className="table table-bordered table-condensed dataTable page_navigation"> */}
        {/* <table className="table table-bordered table-sm"> */}
<div className="scollDiv mt-4">
          {/* <table
            // className="attendTable text-center"
            style={{ width: "100%" }}
          > */}
          <table
  style={{ 
    width: "100%", 
    border: "1px solid #ddd", 
    borderCollapse: "collapse" 
  }}
>
          <thead>
            {/* <tr>
              <th>Sr No</th>
              <th>Employee ID</th>
              <th>Employee Name</th>
              <th>Employee Card No</th>
              <th>Approver ID</th>
              <th>Approver Name</th>
              <th>Approver Card No</th>
            </tr> */}
          </thead>
          <tbody>
            <tr style={{ border: "1px solid #ddd" }}>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>Sr No</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>Employee ID</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>Employee Name</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>Employee Card No</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>Approver ID</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>Approver Name</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>Approver Card No</td>
              <td style={{ display: hideTd ? 'none' : 'table-cell',border: "1px solid #ddd", padding: "8px" }}>Unit Id</td>
              <td style={{ display: hideTd ? 'none' : 'table-cell',border: "1px solid #ddd", padding: "8px"}}>Company Id</td>
            </tr>
            {data.map((row, index) => (
              <tr key={index} style={{ border: "1px solid #ddd" }}>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.SerialNo}</td>
                
                 <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    type="text"
                    value={row.EmployeeId}
                    placeholder="Employee ID"
                    className="form-control"
                    onChange={(e) => {
                      const updatedData = [...data];
                      updatedData[index].EmployeeId = e.target.value;
                      setData(updatedData);
                      //setEmployeeId(e.target.value);
                    }}
                  />
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    type="text"
                    value={row.EmployeeName}
                    placeholder="Employee Name"
                    className="form-control"
                    onChange={(e) => {
                      const updatedData = [...data];
                      updatedData[index].EmployeeName = e.target.value;
                      setData(updatedData);
                      //setEmployeeName(e.target.value);
                    }}
                  />
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    type="text"
                    value={row.EmployeeCardNo}
                    placeholder="Employee Card No"
                    className="form-control"
                    onChange={(e) => {
                      const updatedData = [...data];
                      updatedData[index].EmployeeCardNo = e.target.value;
                      setData(updatedData);
                      //setEmployeeCardNo(e.target.value);
                    }}
                  />
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    type="text"
                    value={row.ApproverId}
                    placeholder="Approver ID"
                    className="form-control"
                    onChange={(e) => {
                      const updatedData = [...data];
                      updatedData[index].ApproverId = e.target.value;
                      setData(updatedData);
                      //setApproverId(e.target.value);
                    }}
                  />
                </td>
                 <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    type="text"
                    value={row.ApproverName}
                    placeholder="Approver Name"
                    className="form-control"
                    onChange={(e) => {
                      const updatedData = [...data];
                      updatedData[index].ApproverName = e.target.value;
                      setData(updatedData);
                      //setApproverName(e.target.value);
                    }}
                  />
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    type="text"
                    value={row.ApproverCardNo}
                    placeholder="Approver Card No"
                    className="form-control"
                    onChange={(e) => {
                      const updatedData = [...data];
                      updatedData[index].ApproverCardNo = e.target.value;
                      setData(updatedData);
                      //setApproverCardNo(e.target.value);
                    }}
                  />
                </td>
                    {/* <td>
                      <input
                      type="text"
                      value={unitId}
                      placeholder="Unit ID"
                      className="form-control"
                      style={{ display: hideTd ? 'none' : 'table-cell', border: "1px solid #ddd", padding: "8px" }}
                      onChange={(e) => setUnitId(e.target.value)}
                    />
                    </td>

                    <td>
                      <input
                      type="text"
                      value={companyId}
                      placeholder="Company ID"
                      className="form-control"
                      style={{ display: hideTd ? 'none' : 'table-cell', border: "1px solid #ddd", padding: "8px" }}
                      onChange={(e) => setCompanyId(e.target.value)}
                    />
                    </td> */}

                <td style={{ display: hideTd ? 'none' : 'table-cell',border: "1px solid #ddd", padding: "8px" }}>{localStorage.getItem("unitId")}</td>
                <td style={{ display: hideTd ? 'none' : 'table-cell',border: "1px solid #ddd", padding: "8px" }}>{localStorage.getItem("companyId")}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>

      {/* <div className="panel-footer">
        <div className="col-md-3 col-sm-12 col-xs-12">
          <button
            className="btn btn-sm theme-btn btn-success"
            onClick={handleSave}
            style={{ borderRadius: "5px" }}
          >
            Save Import Data
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default ImportApprovalAuthority;
